var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookMobileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.37273 0 0 5.40034 0 12.0617C0 18.109 4.43182 23.102 10.2065 23.9742V15.2586H7.23764V12.088H10.2065V9.9783C10.2065 6.48535 11.8996 4.95187 14.7878 4.95187C16.1711 4.95187 16.9025 5.05494 17.2489 5.10209V7.8697H15.2787C14.0525 7.8697 13.6244 9.03804 13.6244 10.355V12.088H17.2178L16.7302 15.2586H13.6244V24C19.4815 23.2012 24 18.1676 24 12.0617C24 5.40034 18.6273 0 12 0Z",
    fill: "#F0F1F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookMobileIcon);
export default __webpack_public_path__ + "static/media/facebook_mobile_icon.b3f875bf5444462af51bd6f3dc117772.svg";
export { ForwardRef as ReactComponent };